export default {
  name: 'second',
  data: function() {
    return {}
  },
  props: ['pressure_influencing', 'landingText'],
  methods: {
    goToThird: function() {
      this.$emit('change-component', 'third-component', this.pressure_influencing)
    },
    setNone: function() {
      this.pressure_influencing.reflux_valve = false
      this.pressure_influencing.pressure_reducers = false
      this.pressure_influencing.water_filters = false
      this.pressure_influencing.backflow_preventers = false
      this.pressure_influencing.water_softeners = false
      this.pressure_influencing.other_pressure_devices = false
    },
    unSetNone: function() {
      this.pressure_influencing.none = false
    }
  },
  beforeMount: function() {

  }
}


// WEBPACK FOOTER //
// ./src/components/plan/subComponents/second/second.js